<div [@fadeInOut] class="hourglass" id="hourglass">
    <div class="hourglass-top"></div>
    <div class="hourglass-glass">
        <div class="hourglass-glass-bottom"></div>
        <div class="hourglass-sand-bottom"></div>
        <div class="hourglass-glass-top">
            <div class="hourglass-sand-top">
                <div class="hourglass-sand-cover-top"></div>
            </div>
        </div>
    </div>
    <div class="hourglass-bottom"></div>
</div>
